{
  "slug": "iq-vs-intelligence",
  "title": "معدل الذكاء مقابل الذكاء: هل هما نفس الشيء؟",
  "description": "فهم الفرق بين معدل الذكاء الموحد والمفهوم الأوسع للذكاء البشري.",
  "summary": "إن الذكاء مفهوم نفسي واسع النطاق. ومعدل الذكاء هو تقدير موحد يستند إلى الأداء في مهام معرفية مختارة.",
  "sections": [
    {
      "heading": "الاستخبارات أوسع من علامة واحدة",
      "paragraphs": [
        "يستخدم علماء النفس الذكاء لمناقشة القدرة على التعلم، والتفكير، وحل المشاكل، والتكيف، واستخدام المعرفة. وتختلف النظريات: فبعضها يؤكد على عامل عام، في حين تصف نظريات أخرى قدرات عامة أو متخصصة متعددة.",
        "إن الذكاء يعمل في بيئات حقيقية. والحقيقة أن المعرفة العملية، والإبداع، والمثابرة، والتجربة الثقافية تشكل الطريقة التي يحل بها الناس المشاكل ذات المعنى."
      ]
    },
    {
      "heading": "معدل الذكاء أداة قياس",
      "paragraphs": [
        "إن معدل الذكاء يلخص عينة من الأداء المعرفي نسبة إلى مجموعة معيارية قائمة على العمر. ومن الممكن أن تتنبأ الاختبارات الجيدة التصميم ببعض النتائج التعليمية والمهنية، ولكن التنبؤ إحصائي وليس قدرا.",
        "لا يوجد اختبار يرصد كل أشكال السلوك الذكي. فالمهام، والتقدير، والمعايير، واللغة، وظروف الاختبار تحدد ما يمكن أن تدعمه النتيجة."
      ]
    },
    {
      "heading": "استخدام الدرجة في المستوى الصحيح",
      "paragraphs": [
        "إن معدل الذكاء مفيد عندما يتوافق السؤال مع الأدلة، مثل وصف أنماط القوى المعرفية والاحتياجات في تقييم شامل. وهو أقل فائدة كمختصر للموهبة، أو الشخصية، أو الإبداع، أو القيمة.",
        "التفسير المتأني يجمع بين الدرجات مع التاريخ، والسلوك، والبيئة، والأهداف، وغيرها من المعلومات ذات الصلة."
      ]
    }
  ],
  "faqs": [
    {
      "question": "هل يقيس معدل الذكاء كل الذكاء؟",
      "answer": "لا، إنه يمثل عينة من القدرات المعرفية الهامة، ولكنه لا يستنفد الإبداع، أو الحكم العملي، أو الحكمة، أو الدافع، أو المهارة العاطفية."
    },
    {
      "question": "هل يمكن لأحد أن يكون ذكياً بمعدل ذكاء متوسط؟",
      "answer": "نعم، يمكن أن يتعايش المركب المتوسط مع نقاط قوة محددة، أو خبرة، أو إبداع، أو حل المشاكل العملية بفعالية."
    }
  ],
  "related": ["what-is-iq", "iq-vs-eq", "how-is-iq-measured"]
}
